import { Component } from '@angular/core';

@Component({
  selector: 'app-editorial-component',
  templateUrl: './editorial.component.html'
})
export class EditorialComponent {
  public currentCount = 0;

  public incrementEditorial() {
    this.currentCount++;
  }
}
